export const APP_INFO = {
    contactEmail: process.env.REACT_APP_CONTACT_EMAIL!,
    developerName: process.env.REACT_APP_DEVELOPER_NAME!,
    originalGameName: process.env.REACT_APP_ORIGINAL_GAME_NAME!,
    originalGameUrl: process.env.REACT_APP_ORIGINAL_GAME_URL!,
} as const;
